import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Steps } from "primereact/steps";
import { getTrackStatus } from "../utils.js"; // твой сервис

export default function TrackModal({ trackingNumber, visible, onHide }) {
    const [steps, setSteps] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [statusAvailable, setStatusAvailable] = useState(true); // новый стейт

    useEffect(() => {
        if (trackingNumber && visible) {
            fetchTrackStatus(trackingNumber);
        }
    }, [trackingNumber, visible]);

    const fetchTrackStatus = async (number) => {
        try {
            const result = await getTrackStatus(number);
            if (result.result === 1 && Array.isArray(result.statuses) && result.statuses.length > 0) {
                const formattedSteps = result.statuses.map((item) => ({
                    label: item.comment_ru,
                    description: item.date
                }));
                setSteps(formattedSteps);
                setActiveIndex(formattedSteps.length - 1);
                setStatusAvailable(true);
            } else {
                setSteps([]);
                setStatusAvailable(false);
            }
        } catch (err) {
            console.error(err);
            setSteps([]);
            setStatusAvailable(false);
        }
    };

    return (
        <Dialog
            header={`Статус трека ${trackingNumber}`}
            visible={visible}
            style={{ width: "40rem" }}
            onHide={onHide}
            footer={
                <div className="p-d-flex p-jc-end">
                    <Button label="Закрыть" className="p-button-text" onClick={onHide} />
                </div>
            }
        >
            {statusAvailable ? (
                steps.length > 0 ? (
                    <Steps model={steps} activeIndex={activeIndex} readOnly className="p-mb-4" />
                ) : (
                    <p>Загрузка статусов...</p>
                )
            ) : (
                <p>Статусы недоступны для данного трека.</p>
            )}
        </Dialog>
    );
}
